<script lang="ts">
    import type {FieldTypeId} from 'src/typings';
    import type {ModalWindowActions} from 'shared/modal-dialogs';
    import type {FondFieldRelationTableModalModel} from 'src/modals/fond-field-relation-table-modal/types';
    import type {DynamicFieldSearchParam, RecordRow, RowCreationParams} from 'src/features/record-grid/lib/types';
    import {createRelationsContext} from 'src/features/record/kp-related-records-table/relations.context';
    import {exists} from 'shared/utils/custom-utils';
    import KpModalContent from '../kp-modal/KpModalContent.svelte';
    import KpModalFooterCloseButton from '../kp-modal/KpModalFooterCloseButton.svelte';
    import KpRecordGrid from 'src/features/record-grid/KpRecordGrid.svelte';
    import KpModalTitle from 'src/modals/kp-modal/KpModalTitle.svelte';
    import KpModalHeaderCloseButton from 'src/modals/kp-modal/KpModalHeaderCloseButton.svelte';
    import RelationsRowOptionsCell from 'src/features/record/kp-related-records-table/RelationsRowOptionsCell.svelte';
    import {isNotEmpty} from 'shared/utils/array-utils';

    export let model: FondFieldRelationTableModalModel;
    export let modalWindowActions: ModalWindowActions;

    createRelationsContext(model.relation.relations);

    function createDynamicFieldSearchParams(targetLinkFieldTypeId: FieldTypeId, item: RecordRow): DynamicFieldSearchParam[] {
        return [{fieldTypeId: targetLinkFieldTypeId, type: 'link', value: item.id}];
    }

    function createRowCreationParams(targetLinkFieldTypeId: FieldTypeId, item: RecordRow): RowCreationParams {
        return {initialValues: {[targetLinkFieldTypeId]: {recordId: item.id}}};
    }
</script>

<KpModalContent {modalWindowActions} additionalClasses="relation-table-modal">
    <svelte:fragment slot="header">
        <KpModalHeaderCloseButton/>
        <KpModalTitle>{model.relation.text}</KpModalTitle>
    </svelte:fragment>

    <svelte:fragment slot="body">
        <KpRecordGrid fondOrFondId={model.relation.targetFondId}
                      {...exists(model.relation.relations) && isNotEmpty(model.relation.relations) ? {rowOptionsCellComponent: RelationsRowOptionsCell} : {}}
                      referenceRecordId={model.item.id}
                      dynamicFieldSearchParams={createDynamicFieldSearchParams(model.relation.targetLinkFieldTypeId, model.item)}
                      rowCreationParams={createRowCreationParams(model.relation.targetLinkFieldTypeId, model.item)}/>
    </svelte:fragment>

    <svelte:fragment slot="footer">
        <KpModalFooterCloseButton action="acknowledge" dataQa="finished-response-close-button"/>
    </svelte:fragment>
</KpModalContent>

<style lang="less">
    :global {
        .relation-table-modal {
            .kp-modal-body {
                padding: 0 !important;

                .kp-generic-grid-container {
                    display: block !important;
                    border-bottom: none !important;
                    border-left: none !important;
                    border-right: none !important;
                }
            }
        }
    }
</style>